import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { forgetPassword } from "../actions/userActions";
import Loader from "../components/Loader";
import Message from "../components/Message";

const ForgotPassword = ({ history }) => {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const { success, loading, error } = useSelector(
    (state) => state.forgetPassword
  );
  const dispatch = useDispatch();

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
    if (!!errors[field])
      setErrors({
        ...errors,
        [field]: null,
      });
  };

  const findFormErrors = () => {
    const { email } = form;
    const newErrors = {};
    // email errors
    if (!email || email === "") newErrors.email = "This field is required";
    return newErrors;
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const merchant = {
        email: form.email,
        platform: "EMONEY", 
      };
      dispatch(forgetPassword(merchant));
    }
  };  

  return (
    <div className="">
      {loading && <Loader />}

      <section className="mt-4">
        <div className="row d-flex justify-content-center">
          <div className="col-lg-6">
            {/* Show success or error message */}
            {error && <Message variant="danger">{error}</Message>}
            {success && (
              <Message variant="success">
                Reset link sent to your email. Please check.
              </Message>
            )}

            <h3>Forgot your Password?</h3>

            <form className="" onSubmit={submitHandler}>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="text"
                  className="form-control mb-0"
                  id="email"
                  name="email"
                  placeholder="Email"
                  onChange={(e) => setField("email", e.target.value)}
                  isInvalid={!!errors.email}
                />
                <label htmlFor="email" type="invalid" className="error">
                  {errors.email && errors.email}
                </label>
              </div>

              <button
                type="submit"
                className="btn btn-danger"
                disabled={loading} // Disable button while loading
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForgotPassword;
